<template>
  <div v-if="zodiacData" class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-lg border border-purple-200 p-6">
    <div class="flex items-center gap-4 mb-6">
      <div class="text-6xl text-psychology-primary filter drop-shadow-sm">{{ zodiacData.icon }}</div>
      <div class="flex-1">
        <h3 class="text-2xl font-bold text-gray-900">{{ zodiacData.name }}</h3>
        <p class="text-sm text-gray-600">星座专属恋爱分析</p>
      </div>
    </div>

    <!-- 星座特质标签 -->
    <div class="mb-6">
      <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>✨</span>
        <span>性格特质</span>
      </h4>
      <div class="flex flex-wrap gap-2">
        <span 
          v-for="trait in zodiacData.traits" 
          :key="trait"
          class="px-4 py-2 bg-white rounded-full text-sm font-medium text-purple-700 border border-purple-200"
        >
          {{ trait }}
        </span>
      </div>
    </div>

    <!-- 恋爱关系特点 -->
    <div class="mb-6">
      <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>💝</span>
        <span>恋爱关系特点</span>
      </h4>
      <p class="text-gray-700 leading-relaxed bg-white p-4 rounded-lg">
        {{ zodiacData.relationship }}
      </p>
    </div>

    <!-- 星座专属建议 -->
    <div>
      <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>💡</span>
        <span>专属建议</span>
      </h4>
      <div class="space-y-2">
        <div 
          v-for="(advice, index) in zodiacData.advice" 
          :key="index"
          class="flex items-start gap-2 p-3 bg-white rounded-lg"
        >
          <span class="text-purple-600 font-semibold mt-0.5">{{ index + 1 }}.</span>
          <span class="text-gray-700 text-sm">{{ advice }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getZodiacData } from '@/data/zodiacData'

export default {
  name: 'ZodiacAnalysis',
  props: {
    zodiac: {
      type: String,
      required: true
    },
    zodiacKey: {
      type: String,
      default: null
    }
  },
  computed: {
    zodiacData() {
      // 兼容两种 prop 名称
      const key = this.zodiac || this.zodiacKey
      return getZodiacData(key)
    }
  }
}
</script>

